var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.66667H12C10.5333 2.66667 9.33333 3.86667 9.33333 5.33333V21.3333C9.33333 22.8 10.5333 24 12 24H24C25.4667 24 26.6667 22.8 26.6667 21.3333V5.33333C26.6667 3.86667 25.4667 2.66667 24 2.66667ZM24 21.3333H12V5.33333H24V21.3333ZM4 20V17.3333H6.66667V20H4ZM4 12.6667H6.66667V15.3333H4V12.6667ZM13.3333 26.6667H16V29.3333H13.3333V26.6667ZM4 24.6667V22H6.66667V24.6667H4ZM6.66667 29.3333C5.2 29.3333 4 28.1333 4 26.6667H6.66667V29.3333ZM11.3333 29.3333H8.66667V26.6667H11.3333V29.3333ZM18 29.3333V26.6667H20.6667C20.6667 28.1333 19.4667 29.3333 18 29.3333ZM6.66667 8V10.6667H4C4 9.2 5.2 8 6.66667 8Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.b114d472f828bb2ccfad06e53e227b27.svg";
export { ForwardRef as ReactComponent };